export default __webpack_public_path__ + "static/media/Phil Weiser.8ae79c6c.jpg";